module.exports = __webpack_public_path__ + "static/media/浩泽社区居民委员会.b1c26fc3.jpg";